import { Divider, Grid } from '@wework/dieter-ui'
import SpaceType from '../SidebarBlocks/SpaceType'
import React from 'react'
import LinkDesk from '../SidebarBlocks/LinkDesk'

export default function EditDesk({ space, roomData, setRoomData }) {
  if (!space) {
    return null
  }
  return (
    <div>
      <Grid style={{ marginTop: 24 }}>
        <SpaceType
          space={space}
          setRoomData={setRoomData}
          roomData={roomData}
          isChair
        />

        <Divider light style={{ width: '100%' }} />
        <LinkDesk space={space} />
        {/* <Divider light style={{ width: '100%' }} /> */}
      </Grid>
    </div>
  )
}
